import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import UserService from '../utils/UserService';

const PROMPT_DISMISS_DURATION = 60 * 60 * 1000 * 3; // 3 hours in milliseconds

export const useTimeSlotPrompt = () => {
  const [showPrompt, setShowPrompt] = useState(false);
  const userInfo = useSelector((state) => state?.user?.userInfo);
  const location = useLocation();

  const isBookingPage = location.pathname === '/bookings';

  useEffect(() => {
    let timer;
    const showTimeInMilliSeconds = 10_000;

    const checkPromptVisibility = () => {
      // Only show for founders who haven't set a time slot
      if (userInfo?.userTypeId === 1 && !userInfo?.hasSlot && !isBookingPage) {
        const lastDismissed = UserService.getTimeSlotPromptDismissed();

        if (!lastDismissed) {
          timer = setTimeout(() => {
            setShowPrompt(true);
          }, showTimeInMilliSeconds);
        } else {
          const timeSinceLastDismissed = Date.now() - parseInt(lastDismissed);
          if (timeSinceLastDismissed >= PROMPT_DISMISS_DURATION) {
            timer = setTimeout(() => {
              setShowPrompt(true);
            }, showTimeInMilliSeconds);
          }
        }
      }
    };

    checkPromptVisibility();

    return () => {
      clearTimeout(timer);
    };
  }, [userInfo, location.pathname]);

  return {
    showPrompt,
    setShowPrompt,
  };
};
